import React from "react";
import { formatCentsAsDollars } from "../../../util/formatters";
import { PharmacyPrimaryBenefits } from "./PharmacyPrimaryBenefits";
import { PharmacySecondaryBenefits } from "./PharmacySecondaryBenefits";
import { featureEnabled } from "../../../util/feature";

export const EstimateInfoListPharmacyUser = ({ biInfo, noMoopProvided = false, coveredChargesEnabled, showSecondaryInsuranceResult }) => {
  return (
    <>
      {showSecondaryInsuranceResult && (
        <li className="flex flex-col items-start justify-center bg-info bg-opacity-25 p-2 pt-3 pb-3 mb-4 rounded" id={`primary-benefits`}>
          <h4 className="text-dark fw-bold mb-0 mx-2">Primary Benefits</h4>
        </li>
      )}

      <PharmacyPrimaryBenefits biInfo={biInfo} coveredChargesEnabled={coveredChargesEnabled} noMoopProvided={noMoopProvided} />

      {showSecondaryInsuranceResult && (
        <li className="flex flex-col items-start justify-center bg-info bg-opacity-25 p-2 pt-3 pb-3 mb-4 rounded" id={`secondary-benefits`}>
          <h4 className="text-dark fw-bold mb-0 mx-2">Secondary Benefits</h4>
        </li>
      )}

      {showSecondaryInsuranceResult && <PharmacySecondaryBenefits biInfo={biInfo.secondaryPayorBenefitsData} />}

      <li
        className="d-flex flex-column align-items-start bg-info bg-opacity-25 rounded pt-3 pb-3 p-2"
        id={`estimated-total-healthplan-responsibility`}
      >
        <h4 className="text-dark fw-bold mb-2 mx-2">Estimated Total HealthPlan Responsibility</h4>
        <h5 className="text-dark fw-bold px-2 pb-1">{formatCentsAsDollars(biInfo.total_charges_covered_by_healthplan)}</h5>
      </li>
    </>
  );
};
